module.exports = __webpack_public_path__ + "static/media/hand_pointer.55315327.png";